import CardElementPhotoPpiWarningModal from './CardElementPhotoPpiWarningModal';

export default CardElementPhotoPpiWarningModal;
